import React, { useState, useRef, createRef } from 'react'
import { Row, Col, Form, FormGroup, InputGroup, FormControl, ButtonGroup, Button, ToggleButton } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import Editor from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import './style.scss'

class NewsForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            inputFileKey: 0
        }
    }

    // https://quilljs.com/docs/modules/toolbar/
    modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link'],
            [{ 'align': [] }],
            ['clean']
        ]
    }

    render() {
        const { entry, prevEntry, updateEntry, saveEntry, deleteEntry, errorMessage, successMessage, availableLegalEntity, availableUserType } = this.props
        let { inputFileKey } = this.state

        return (
            <Form onSubmit={evt => evt.preventDefault()}>
                <fieldset className="myfieldset is-relative smaller-inputs">
                    <legend className="mylegend">{prevEntry?.Title || 'Entry'}</legend>
                    <FormGroup className="select margin-top-10">
                        <InputGroup bsSize="sm">
                            <InputGroup.Addon>Title*</InputGroup.Addon>
                            <FormControl
                                bsSize="sm"
                                componentClass={"input"}
                                readOnly={false}
                                tabIndex={false ? -1 : null}
                                value={entry.Title || ''}
                                title="Entry title"
                                placeholder=""
                                onChange={(e) => updateEntry('Title', e.target.value)}
                                maxLength={150}
                            />
                        </InputGroup>

                        <InputGroup bsSize="sm" className="margin-top-4">
                            <InputGroup.Addon>Attachment</InputGroup.Addon>
                            <div className="np-file-input">
                                <FormControl
                                    id="attachment"
                                    type="file"
                                    accept=".pdf,application/x-gzpdf,.docx,.doc,.jpeg,.jpg,.xlsx,.txt"
                                    key={inputFileKey}
                                    onChange={e => {
                                        let [file] = e.target.files;

                                        if (file) {
                                            let { name: fileName, size } = file;
                                            let fileSize = (size / 1000).toFixed(2);

                                            updateEntry('Attachment', {
                                                Title: fileName,
                                                File: file,
                                                FileSize: `${fileSize}kB`
                                            })
                                        }
                                    }} />
                                <label htmlFor="attachment">Select file... </label>
                                {
                                    entry.Attachment &&
                                    <button type="button" className="np-file-name" onClick={() => {
                                        updateEntry('Attachment', null)

                                        this.setState({
                                            inputFileKey: inputFileKey+=1
                                        })
                                        // Det verkar vara ett problem med att f�rst v�lja en fil, sedan ta bort den, och sedan f�rs�ka v�lja samma fil igen. Detta verkar vara pga. default beteende i webbl�saren, inte pga. React
                                        // L�ste detta genom att anv�nda en key p� inputen, som sedan uppdateras vid ta bort, vilket omrenderar inputen och dess value
                                    }}>
                                        {entry.Attachment?.Title} <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                }
                            </div>
                        </InputGroup>

                        <InputGroup bsSize="sm" className="margin-top-4">
                            <InputGroup.Addon>News content</InputGroup.Addon>
                            <Editor
                                theme="snow"
                                value={entry.NewsContent}
                                modules={this.modules}
                                onChange={(value) => updateEntry('NewsContent', value)} />
                        </InputGroup>

                        <ButtonGroup className="np-radio-wrapper margin-top-4" toggle="toggle">
                            <InputGroup.Addon>Legal entity</InputGroup.Addon>
                            {availableLegalEntity.map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    type="radio"
                                    variant="secondary"
                                    name="radio"
                                    value={radio.value || ''}
                                    checked={radio.value === entry.LegalEntity}
                                    className={radio.value === entry.LegalEntity ? 'active' : ''}
                                    onChange={(e) => updateEntry('LegalEntity', e.target.value)}
                                >
                                    {radio.label}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>

                        <ButtonGroup className="np-radio-wrapper margin-top-4" toggle="toggle">
                            <InputGroup.Addon>User type</InputGroup.Addon>
                            {availableUserType.map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    type="radio"
                                    variant="secondary"
                                    name="radio"
                                    value={radio.value || ''}
                                    checked={radio.value == entry.UserType}
                                    className={radio.value == entry.UserType ? 'active' : ''}
                                    onChange={(e) => updateEntry('UserType', e.target.value)}
                                >
                                    {radio.label}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>

                        <ButtonGroup className="np-radio-wrapper margin-top-4" toggle="toggle">
                            <InputGroup.Addon>Published</InputGroup.Addon>
                            <div className="np-switch-wrapper">
                                <span className="np-switch">
                                    <input type="checkbox"
                                        value={entry.Published}
                                        checked={entry.Published}
                                        onChange={(e) => updateEntry('Published', e.target.value)} />
                                    <span className="slider" onClick={() => updateEntry('Published', !entry.Published)}></span>
                                </span>
                            </div>                         
                        </ButtonGroup>

                        <div className="margin-top-10">
                            <Col className="text-right">
                                {
                                    successMessage &&
                                    <div>
                                        <label>{successMessage}</label>
                                    </div>
                                }
                                {
                                    errorMessage &&
                                    <div>
                                        <label className="danger">{errorMessage}</label>
                                    </div>
                                }
                            </Col>
                            <Button bsStyle="primary pull-right" onClick={saveEntry} disabled={entry.Title == ''}>Save</Button>
                            <Button bsStyle="danger margin-right-10 pull-right" onClick={deleteEntry} disabled={entry.Id == null}>Delete</Button>
                        </div>
                    </FormGroup>
                </fieldset>
            </Form>
        )
    }
}

export default NewsForm;
